module.exports = __webpack_public_path__ + "static/media/homepage.685500eb.jpg";